import { SuccessModalContainer } from "./SuccessModalContainer";
import { SuccessModalIcon } from "./SuccessModalIcon";
import { Typography } from "@mui/material";
import { SuccessModalDescription } from "./SuccessModalDescription";
import { SuccessModalActionsContainer } from "./SuccessModalActionsContainer";
import { RootState } from "../../../../../redux/store";
import { useSelector } from "react-redux";
import { SuccessModalButton } from "./SuccessModalButton";
import { SuccessModalTitle } from "./SuccessModalTitle";

export const ResetPasswordSuccessModal = () => {
  const colors = useSelector((state: RootState) => state.theme.componentColors);

  return (
    <SuccessModalContainer key={"success-modal"}>
      <SuccessModalContainer>
        <SuccessModalIcon />

        <SuccessModalTitle>Password updated!</SuccessModalTitle>

        <SuccessModalDescription>
          <Typography
            sx={{ color: colors.surface.onSurface, textAlign: "center" }}
          >
            Your password has been updated successfully!
          </Typography>
          <Typography
            sx={{ color: colors.surface.onSurface, textAlign: "center" }}
          >
            You can now log in to your account.
          </Typography>
        </SuccessModalDescription>

        <SuccessModalActionsContainer>
          <SuccessModalButton>Log In</SuccessModalButton>
        </SuccessModalActionsContainer>
      </SuccessModalContainer>
    </SuccessModalContainer>
  );
};
